import { connect } from "react-redux";
import Component from "./RemovePED";

export default connect(
    null,
    ({ scp: { RemovePED } }) => ({ RemovePED })
)(Component);
